// MOSSLAR + SU ÜSTÜ BİTKİLERİ - bitkiVeritabani6.js
// Yosunlar ve Yüzen/Su Üstü Bitkiler (29 bitki)

export const mosslarVeSuUstuBitkiler = [
  // ==================== MOSSLAR (Yosunlar) ====================
  {
    id: 'taxiphyllum-barbieri',
    isim: 'Java Moss',
    latince: 'Taxiphyllum barbieri',
    resim: '/images/bitkiler/taxiphyllum-barbieri.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Low Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '3-10 cm',
    genislik: '5-20 cm',
    sicaklik: '18-28°C',
    ph: '5.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Çok kolay',
    konum: 'Her yerde',
    aciklama: 'En popüler akvaryum yosunu. Taş, kütük veya ağa bağlanır.'
  },
  {
    id: 'vesicularia-dubyana',
    isim: 'Singapur Moss',
    latince: 'Vesicularia dubyana',
    resim: '/images/bitkiler/vesicularia-dubyana.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Low Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '3-10 cm',
    genislik: '5-15 cm',
    sicaklik: '20-28°C',
    ph: '5.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Her yerde',
    aciklama: 'Java Moss\'a benzer, biraz daha ince yapılı.'
  },
  {
    id: 'vesicularia-montagnei',
    isim: 'Christmas Moss',
    latince: 'Vesicularia montagnei',
    resim: '/images/bitkiler/vesicularia-montagnei.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Low Tech',
    habitat: 'Asya',
    uzunluk: '3-10 cm',
    genislik: '5-15 cm',
    sicaklik: '20-28°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Her yerde',
    aciklama: 'Çam ağacı dalları gibi görünüm. Çok dekoratif.'
  },
  {
    id: 'taxiphyllum-flame',
    isim: 'Flame Moss',
    latince: 'Taxiphyllum sp. Flame',
    resim: '/images/bitkiler/taxiphyllum-flame.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Low Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '5-15 cm',
    genislik: '5-10 cm',
    sicaklik: '20-28°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Her yerde',
    aciklama: 'Dikey büyüyen, alev gibi görünüm.'
  },
  {
    id: 'fissidens-fontanus',
    isim: 'Phoenix Moss',
    latince: 'Fissidens fontanus',
    resim: '/images/bitkiler/fissidens-fontanus.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Mid Tech',
    habitat: 'Kuzey Amerika',
    uzunluk: '2-5 cm',
    genislik: '3-10 cm',
    sicaklik: '18-26°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Çok yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan / Hardscape',
    aciklama: 'Tüy gibi ince yapraklar. Çok yavaş büyür.'
  },
  {
    id: 'riccardia-chamedryfolia',
    isim: 'Mini Pellia (Coral Moss)',
    latince: 'Riccardia chamedryfolia',
    resim: '/images/bitkiler/riccardia-chamedryfolia.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Mid Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '1-3 cm',
    genislik: '3-10 cm',
    sicaklik: '20-28°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Çok yavaş',
    bakimZorlugu: 'Orta',
    konum: 'Ön plan / Hardscape',
    aciklama: 'Mercan benzeri görünüm. Çok yavaş ama çok dekoratif.'
  },
  {
    id: 'monosolenium-tenerum',
    isim: 'Pellia',
    latince: 'Monosolenium tenerum',
    resim: '/images/bitkiler/monosolenium-tenerum.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Low Tech',
    habitat: 'Asya',
    uzunluk: '2-5 cm',
    genislik: '5-15 cm',
    sicaklik: '18-28°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Ön plan / Yüzen',
    aciklama: 'Karaciğerotu. Bağlanmadan da yetişir, kırılgan.'
  },
  {
    id: 'riccia-fluitans',
    isim: 'Riccia (Kristal Yosun)',
    latince: 'Riccia fluitans',
    resim: '/images/bitkiler/riccia-fluitans.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Mid Tech',
    habitat: 'Kozmopolit',
    uzunluk: '1-5 cm',
    genislik: '5-20 cm',
    sicaklik: '18-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Yüzen / Bağlı',
    aciklama: 'Parlak yeşil, oksijen kabarcıkları oluşturur. Bağlamak gerekir.'
  },
  {
    id: 'taxiphyllum-alternans',
    isim: 'Taiwan Moss',
    latince: 'Taxiphyllum alternans',
    resim: '/images/bitkiler/taxiphyllum-alternans.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Low Tech',
    habitat: 'Tayvan',
    uzunluk: '3-8 cm',
    genislik: '5-15 cm',
    sicaklik: '18-26°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Her yerde',
    aciklama: 'Üçgen şeklinde dallanma. Serin suyu tercih eder.'
  },
  {
    id: 'vesicularia-ferriei',
    isim: 'Weeping Moss',
    latince: 'Vesicularia ferriei',
    resim: '/images/bitkiler/vesicularia-ferriei.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Low Tech',
    habitat: 'Çin',
    uzunluk: '3-10 cm',
    genislik: '5-15 cm',
    sicaklik: '18-26°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş - Orta',
    bakimZorlugu: 'Kolay',
    konum: 'Her yerde',
    aciklama: 'Aşağı sarkan dalları ile söğüt ağacı efekti.'
  },
  {
    id: 'callicostella-prabaktiana',
    isim: 'Anchor Moss',
    latince: 'Callicostella prabaktiana',
    resim: '/images/bitkiler/callicostella-prabaktiana.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Low Tech',
    habitat: 'Güneydoğu Asya',
    uzunluk: '2-5 cm',
    genislik: '3-10 cm',
    sicaklik: '22-28°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Kolay',
    konum: 'Her yerde',
    aciklama: 'Kendi kendine tutunabilen nadir moss.'
  },
  {
    id: 'fontinalis-antipyretica',
    isim: 'Willow Moss',
    latince: 'Fontinalis antipyretica',
    resim: '/images/bitkiler/fontinalis-antipyretica.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Mid Tech',
    habitat: 'Avrupa, Kuzey Amerika',
    uzunluk: '5-25 cm',
    genislik: '5-15 cm',
    sicaklik: '10-24°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Orta',
    bakimZorlugu: 'Orta',
    konum: 'Her yerde',
    aciklama: 'Serin su yosunu. Soğuk su akvaryumları için ideal.'
  },
  {
    id: 'leptodictyum-riparium',
    isim: 'Stringy Moss',
    latince: 'Leptodictyum riparium',
    resim: '/images/bitkiler/leptodictyum-riparium.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Low Tech',
    habitat: 'Kozmopolit',
    uzunluk: '5-15 cm',
    genislik: '5-20 cm',
    sicaklik: '15-26°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Her yerde',
    aciklama: 'İpliksi uzun dalları ile farklı bir görünüm.'
  },
  {
    id: 'plagiomnium-affine',
    isim: 'Pearl Moss',
    latince: 'Plagiomnium affine',
    resim: '/images/bitkiler/plagiomnium-affine.jpg',
    kategori: 'Mosslar',
    techSeviye: 'Mid Tech',
    habitat: 'Asya, Avrupa',
    uzunluk: '2-5 cm',
    genislik: '3-10 cm',
    sicaklik: '15-24°C',
    ph: '6.0-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Önerilen',
    buyumeHizi: 'Yavaş',
    bakimZorlugu: 'Orta - Zor',
    konum: 'Ön plan',
    aciklama: 'Yuvarlak yapraklı nadir moss. Serin su sever.'
  },

  // ==================== SU ÜSTÜ / YÜZEN BİTKİLER ====================
  {
    id: 'limnobium-laevigatum',
    isim: 'Amazon Frogbit',
    latince: 'Limnobium laevigatum',
    resim: '/images/bitkiler/limnobium-laevigatum.jpg',
    kategori: 'Su Üstü Bitkileri',
    techSeviye: 'Low Tech',
    habitat: 'Güney Amerika',
    uzunluk: '2-5 cm',
    genislik: '3-8 cm (yaprak)',
    sicaklik: '20-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Yüzen',
    aciklama: 'Yuvarlak yapraklı yüzen bitki. Uzun kökler sarkıtır.'
  },
  {
    id: 'salvinia-natans',
    isim: 'Salvinia',
    latince: 'Salvinia natans',
    resim: '/images/bitkiler/salvinia-natans.jpg',
    kategori: 'Su Üstü Bitkileri',
    techSeviye: 'Low Tech',
    habitat: 'Avrupa, Asya',
    uzunluk: '1-2 cm',
    genislik: '1-2 cm (yaprak)',
    sicaklik: '18-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Yüzen',
    aciklama: 'Küçük yapraklı hızlı yayılan yüzen bitki.'
  },
  {
    id: 'salvinia-auriculata',
    isim: 'Kulak Salvinia',
    latince: 'Salvinia auriculata',
    resim: '/images/bitkiler/salvinia-auriculata.jpg',
    kategori: 'Su Üstü Bitkileri',
    techSeviye: 'Low Tech',
    habitat: 'Amerika',
    uzunluk: '2-3 cm',
    genislik: '2-3 cm (yaprak)',
    sicaklik: '20-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Yüzen',
    aciklama: 'Tüylü yapraklı yüzen bitki.'
  },
  {
    id: 'salvinia-minima',
    isim: 'Mini Salvinia',
    latince: 'Salvinia minima',
    resim: '/images/bitkiler/salvinia-minima.jpg',
    kategori: 'Su Üstü Bitkileri',
    techSeviye: 'Low Tech',
    habitat: 'Amerika',
    uzunluk: '0.5-1 cm',
    genislik: '0.5-1 cm (yaprak)',
    sicaklik: '18-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Yüzen',
    aciklama: 'En küçük Salvinia türü.'
  },
  {
    id: 'phyllanthus-fluitans',
    isim: 'Kırmızı Kök Yüzer',
    latince: 'Phyllanthus fluitans',
    resim: '/images/bitkiler/phyllanthus-fluitans.jpg',
    kategori: 'Su Üstü Bitkileri',
    techSeviye: 'Mid Tech',
    habitat: 'Güney Amerika',
    uzunluk: '2-4 cm',
    genislik: '2-4 cm (yaprak)',
    sicaklik: '22-28°C',
    ph: '5.5-7.5',
    sertlik: 'Yumuşak',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Orta - Hızlı',
    bakimZorlugu: 'Orta',
    konum: 'Yüzen',
    aciklama: 'Yüksek ışıkta kırmızı yapraklar ve kökler.'
  },
  {
    id: 'pistia-stratiotes',
    isim: 'Su Marulu',
    latince: 'Pistia stratiotes',
    resim: '/images/bitkiler/pistia-stratiotes.jpg',
    kategori: 'Su Üstü Bitkileri',
    techSeviye: 'Low Tech',
    habitat: 'Pantropik',
    uzunluk: '5-15 cm',
    genislik: '5-15 cm',
    sicaklik: '22-28°C',
    ph: '6.5-7.5',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Yüksek',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Yüzen',
    aciklama: 'Rozet formlu büyük yüzen bitki. Uzun kökler.'
  },
  {
    id: 'eichhornia-crassipes',
    isim: 'Su Sümbülü',
    latince: 'Eichhornia crassipes',
    resim: '/images/bitkiler/eichhornia-crassipes.jpg',
    kategori: 'Su Üstü Bitkileri',
    techSeviye: 'Low Tech',
    habitat: 'Güney Amerika',
    uzunluk: '15-30 cm',
    genislik: '15-25 cm',
    sicaklik: '20-30°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Çok yüksek',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Yüzen',
    aciklama: 'Mor çiçek açan büyük yüzen bitki. Açık havuz için ideal.'
  },
  {
    id: 'lemna-minor',
    isim: 'Su Mercimeği',
    latince: 'Lemna minor',
    resim: '/images/bitkiler/lemna-minor.jpg',
    kategori: 'Su Üstü Bitkileri',
    techSeviye: 'Low Tech',
    habitat: 'Kozmopolit',
    uzunluk: '0.2-0.5 cm',
    genislik: '0.2-0.5 cm',
    sicaklik: '10-28°C',
    ph: '5.0-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Düşük - Yüksek',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Çok kolay',
    konum: 'Yüzen',
    aciklama: 'En küçük çiçekli bitkilerden. Kontrol edilmezse istilacı.'
  },
  {
    id: 'wolffia-arrhiza',
    isim: 'Su Omurcası',
    latince: 'Wolffia arrhiza',
    resim: '/images/bitkiler/wolffia-arrhiza.jpg',
    kategori: 'Su Üstü Bitkileri',
    techSeviye: 'Low Tech',
    habitat: 'Kozmopolit',
    uzunluk: '0.1 cm',
    genislik: '0.1 cm',
    sicaklik: '15-28°C',
    ph: '5.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Orta',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Yüzen',
    aciklama: 'Dünyanın en küçük çiçekli bitkisi. Balık yemi olarak kullanılır.'
  },
  {
    id: 'azolla-filiculoides',
    isim: 'Peri Eğreltisi',
    latince: 'Azolla filiculoides',
    resim: '/images/bitkiler/azolla-filiculoides.jpg',
    kategori: 'Su Üstü Bitkileri',
    techSeviye: 'Low Tech',
    habitat: 'Amerika',
    uzunluk: '1-2 cm',
    genislik: '1-2 cm',
    sicaklik: '15-28°C',
    ph: '5.5-8.0',
    sertlik: 'Yumuşak - Sert',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Gerekli değil',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Yüzen',
    aciklama: 'Yüksek ışıkta kırmızıya döner. Azot bağlar.'
  },
  {
    id: 'ceratopteris-thalictroides',
    isim: 'Su Sprite (Yüzen)',
    latince: 'Ceratopteris thalictroides',
    resim: '/images/bitkiler/ceratopteris-thalictroides.jpg',
    kategori: 'Su Üstü Bitkileri',
    techSeviye: 'Low Tech',
    habitat: 'Pantropik',
    uzunluk: '15-30 cm',
    genislik: '15-30 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Yüzen / Dikilir',
    aciklama: 'Hem yüzen hem dikilen form. Çok hızlı büyüyen eğrelti.'
  },
  {
    id: 'ceratopteris-cornuta',
    isim: 'Boynuzlu Su Sprite',
    latince: 'Ceratopteris cornuta',
    resim: '/images/bitkiler/ceratopteris-cornuta.jpg',
    kategori: 'Su Üstü Bitkileri',
    techSeviye: 'Low Tech',
    habitat: 'Afrika, Asya',
    uzunluk: '20-40 cm',
    genislik: '20-35 cm',
    sicaklik: '22-28°C',
    ph: '6.0-8.0',
    sertlik: 'Yumuşak - Orta',
    isikIhtiyaci: 'Orta - Yüksek',
    co2Ihtiyaci: 'Opsiyonel',
    buyumeHizi: 'Çok hızlı',
    bakimZorlugu: 'Kolay',
    konum: 'Yüzen / Dikilir',
    aciklama: 'Geniş parçalı yapraklı hızlı büyüyen tür.'
  }
];

export default mosslarVeSuUstuBitkiler;